export const PUBLIC_ROUTES = [
    '/auth/recover-password',
    '/auth/register-simple',
    '/auth/register',
    '/auth/reset-password',
    '/kiosk/login',
    '/questionnaire/completion'
];
